import { useAuth0 } from "@auth0/auth0-react";
import { useCallback } from "react";

const AUTH0_AUDIENCE = import.meta.env.VITE_AUTH0_AUDIENCE;

export function useAuth0AccessToken() {
  const { getAccessTokenSilently, isAuthenticated } = useAuth0();

  return useCallback(async () => {
    if (!isAuthenticated) {
      throw new Error("User is not authenticated");
    }
    if (!AUTH0_AUDIENCE) {
      throw new Error("Missing Auth0 audience configuration");
    }
    return await getAccessTokenSilently({
      authorizationParams: {
        audience: AUTH0_AUDIENCE,
      },
    });
  }, [getAccessTokenSilently, isAuthenticated]);
}
